import "./LogoAndEaseMenu.css";
import React, {useState, useEffect} from "react";
import DarkModeToggle from './DarkModeToggle.js';
import axios from 'axios';
import { ApiKey, dataUrl} from '../config.js'
import Spinner from './Spinner.js';
import RevisionSchedulerList from "./RevisionSchedulerList.js";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HomeIcon from "@mui/icons-material/Home";



export default function LogoAndEaseMenu({ OnClickFunction, onClickEaseMenu, isIconizedMenu, notificationCount})
{
    return (
    <div className={ "AllMenusSidebar z-[993] bg-[var(--bg-color)] fixed top-0 left-0 flex flex-row w-full h-[40px] py-30px items-center justify-start shadow-md md:shadow-none md:flex-col md:w-[50px] md:h-[auto] md:items-center md:justify-start md:left-[10px] md:top-[4vh] "  + (isIconizedMenu ? " md:h-svh md:w-[60px] z-[994]" : "")}>
      <IconButton onClick={onClickEaseMenu}  sx={{
    p: 0,
    width: "40px",
    height: "40px",
    backgroundColor: "var(--bgmain2)",
    border: "var(--bordermain)",
    borderRadius: "0.5vw",
    color: "var(--textmain1)",
    "& .MuiSvgIcon-root": {
      color: "var(--textmain1)"
    }
  }}>
        <Badge badgeContent={notificationCount} color="error">
          <span  className={"flex items-center justify-center leading-none text-[var(--textmain1)]" }>
          <MenuIcon />
          </span>
        </Badge>
      </IconButton>

      <IconButton
        onClick={OnClickFunction}
        sx={{
          p: 0,
          width: "40px",
          height: "40px",
          backgroundColor: "var(--bgmain2)",
          border: "var(--bordermain)",
          borderRadius: "0.5vw",
          color: "var(--textmain1)",
          "& .MuiSvgIcon-root": {
            color: "var(--textmain1)",
          },
        }}
      >
        {isIconizedMenu ? <CloseIcon /> : <HomeIcon />}
      </IconButton>
      <span className="cclogorotate block md:hidden">C-C</span>
      <span className="cclogorotate hidden md:block md:[writing-mode:vertical-lr] md:rotate-180">C-I-V-I-L-S-C-O-D-E</span>
      </div>);
}

export function EaseMenuDiag({subjects, OnSearchResults, backToLogin, loadContentPage, revisions, onRevisionsUpdate})
{
    const [search, setSearch] = useState('');
    const [isLoading, setIsLoading] = useState(false);


    function OnSearch(searchstring)
  {
    if(searchstring.length<=3)
      return
    setIsLoading(true);
    var req = {
      email: localStorage.getItem('user'),
      method: 'SearchWebsite',
      params: {
        SearchString: searchstring
      }
    };
    const headers = { 
      'x-api-key': ApiKey
    };
    axios.post(dataUrl, req, { withCredentials: true, headers:headers}).then(resp => {
      setIsLoading(false);
      OnSearchResults(resp.data, searchstring);
    }).catch(err => {console.log(err);
       OnSearchResults(null, searchstring);
      
    });
  }

  function onLogout()
  {
    localStorage.clear();
    sessionStorage.clear();
    // API request to Server.
    window.location.reload();
  };


    return (
      <div>
      {isLoading ? <Spinner wholepage={true}/> : 
        <div className="EaseMenuDiag">
                <form className='menu_search' onSubmit={(e) => { e.preventDefault();OnSearch(search); }}>
                <input type="text" placeholder="Search Topic" name="search" class="menu_search--bar" value={search} onChange={(e) => setSearch(e.target.value)}/>
                <button class="menu_search--button" disabled={search.length < 3}>
                                 <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M779.385-153.846 528.923-404.307q-30 25.538-69 39.538-39 14-78.385 14-96.1 0-162.665-66.529-66.566-66.529-66.566-162.577t66.529-162.702q66.529-66.654 162.577-66.654 96.049 0 162.702 66.565Q610.769-676.101 610.769-580q0 41.692-14.769 80.692-14.769 39-38.769 66.693l250.462 250.461-28.308 28.308ZM381.538-390.769q79.616 0 134.423-54.808Q570.769-500.385 570.769-580q0-79.615-54.808-134.423-54.807-54.808-134.423-54.808-79.615 0-134.423 54.808Q192.308-659.615 192.308-580q0 79.615 54.807 134.423 54.808 54.808 134.423 54.808Z"></path></svg>
                </button>
                </form>
            <div className="menu_other">
              <DarkModeToggle />
              <button type="button" class="menu_other--logout" onClick={() => {onLogout();}}>Logout</button>
            </div>
            <RevisionSchedulerList subjects={subjects} backToLogin={backToLogin} loadContentPage={loadContentPage} revisions={revisions} onRevisionsUpdate={onRevisionsUpdate}/>
        </div>
      }
      </div>
    );
}
